export default __webpack_public_path__ + "static/SONY_WDR_STRENGTH_5_thumb-e2cc696e3b8cf71f9d5eebbe05de5368.webp";